import React, { useCallback } from 'react'
import { LockOutlined } from '@mui/icons-material'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'
import paths from '@app/src/wf-constants/paths'
import ErrorPage from './base'

const ForbiddenPage: React.FC = () => {
  const { formatMessage } = useIntl()
  const history = useHistory()

  const handleGoHome = useCallback(() => {
    history.push(paths.dashboard)
  }, [history])

  return (
    <ErrorPage
      title={formatMessage({ id: 'errors.403.title' })}
      description={formatMessage({
        id: 'errors.403.message',
      })}
      buttonText={formatMessage({ id: 'errors.goHome' })}
      onButtonClick={handleGoHome}
      iconComponent={LockOutlined}
      testId="page-403"
      buttonTestId="go-home-button"
    />
  )
}

export default ForbiddenPage
